export default __webpack_public_path__ + "static/3-eca8003fc1180c5f9c47ba09720819c4.jpeg";